import classNames from 'classnames'
// @ts-ignore
import iso3311a2 from 'iso-country-lookup'

import { getFlagURL } from '../lib/helper'

const CountryBadge = ({
	isoCode,
	isHighlighted = false,
	classes,
	append = '',
}: {
	isoCode: string
	isHighlighted?: boolean
	classes?: string[]
	append?: string
}) => {
	return (
		<span
			className={classNames(...(classes ?? []), {
				'country-badge': true,
				highlighted: isHighlighted,
			})}
		>
			<img
				alt={iso3311a2.getCountry(isoCode.toUpperCase()) + ' flag'}
				src={getFlagURL(isoCode)}
				className="flag"
				height={14}
				width={21}
			/>
			{iso3311a2.getCountry(isoCode.toUpperCase())}
			{append}
		</span>
	)
}

export default CountryBadge
